export default __webpack_public_path__ + "static/shelter-ceeddabd9b3c3e95aa6293f7adbe8711.png";